// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 960) return "js/960.js";
	if (chunkId === 245) return "js/245.js";
	if (chunkId === 347) return "js/347.js";
	// return url for filenames based on template
	return undefined;
};